import React from 'react'
import Header from './Header'
import { useSelector } from 'react-redux'
import Loginpage from './LoginPage'
import FirstMainContainer from './FirstMainContainer'
import useMovieList from '../Hooks/useMovieList'
import SecondContainer from './SecondContainer'
import GPTsearchPage from './GPTsearchPage'

function Browse() {
    
    const gptOn=useSelector(store=>store.gpt.showMainContainer)
    const user=useSelector(store=>store.user)
    
    const movielist=useMovieList()
    
    
    //Math.floor(Math.random()*user.length)
    
  
    
    
    
    return (
        <>
        <Header/>
       { user &&<div className=''>
            {gptOn?<GPTsearchPage/>:
                <> 
                    
                <FirstMainContainer />
                <SecondContainer/></>}
           
        </div>}
        </>
    )
}

export default Browse
